import {all, call, put, race, select, take, takeLatest, takeLeading} from 'redux-saga/effects'
import axios from "axios";
import oidc from "../oidc";
import {getLanguageUrlParameter} from "../util";

function* authCycle() {
    while (true) {
        yield take('AUTH_SUCCESSFUL');
        yield race({
            task: call(keepTokenFresh),
            cancel: take('TOKEN_INVALID')
        });
    }
}

function* keepTokenFresh() {
    const BASE_DELAY_SECONDS = 5;
    while(true) {
        try {
            let refreshed = yield keycloakPromise(window.keycloak.updateToken(3 + BASE_DELAY_SECONDS));
            if (refreshed) {
                updateAxiosAccessToken();
                yield put({
                    type: 'TOKEN_REFRESHED',
                    firstName: window.keycloak.tokenParsed.given_name,
                    language: window.keycloak.tokenParsed.locale
                });
            }
        }
        catch (error) {
            if (window.keycloak.isTokenExpired(BASE_DELAY_SECONDS)) {
                sessionStorage.removeItem("oidc");
                yield put({
                    type: 'TOKEN_INVALID',
                    error
                })
            }
        }
        yield delay(BASE_DELAY_SECONDS * 1000);
    }
}

export function updateAxiosAccessToken() {
    axios.interceptors.request.use(function (config) {
        const token = window.keycloak.token;
        config.headers.Authorization = "Bearer "+token;
        return config;
    });
}

const delay = (ms) => new Promise(res => setTimeout(res, ms))

const keycloakPromise = (promise) => new Promise((resolve, reject) => promise.success(resolve).error(reject));

export function* requiresAuthentication() {
    let state = yield select();

    if (!state.oidc.authenticated)
        yield take('AUTH_SUCCESSFUL');
}

function* authenticate(){
    try {
        yield oidc();
        updateAxiosAccessToken();
        let languageInUrl = getLanguageUrlParameter();
        yield put({
            type: 'AUTH_SUCCESSFUL',
            firstName: window.keycloak.tokenParsed.given_name,
            language: languageInUrl == null ? window.keycloak.tokenParsed.locale : languageInUrl
        });
        if(languageInUrl != null)
            yield put({
                type: 'CHANGE_LANGUAGE',
                language: languageInUrl
            });
    }
    catch(error) {
        sessionStorage.removeItem("oidc");
        yield put({
            type: 'AUTH_ERROR',
            error
        });
    }
}

function logout() {
    sessionStorage.removeItem("oidc");
    window.keycloak.logout({
        redirectUri: window.keycloak.idTokenParsed.logoutUrl
    });
}

export default function* authSaga() {
    yield all([
        call(authCycle),
        takeLatest('LOGIN', authenticate),
        takeLeading('LOGOUT', logout)
    ]);
}